import { api } from "@/lib/api";
import {
  CreateDepartment,
  createDepartmentToDto,
  Department,
  DepartmentDtoSchema,
  departmentFromDto,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getDepartmentsQueryOptions } from "./get.hooks";

export function useCreateDepartment(opts?: {
  onSuccess?: (department: Department) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (department: CreateDepartment) => {
      const dto = createDepartmentToDto(department);
      const result = await api.post(
        "/api/departments",
        dto,
        DepartmentDtoSchema,
      );
      return departmentFromDto(result);
    },
    onSuccess: (department) => {
      queryClient.setQueryData(getDepartmentsQueryOptions.queryKey, (old) => [
        ...(old ?? []),
        department,
      ]);
      toast({
        title: "toast.departmentCreated",
        variant: "success",
      });
      opts?.onSuccess?.(department);
    },
    onError: () => {
      toast({
        title: "toast.createDepartmentError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
